import axios from "axios";
import { API_ENDPOINTS } from "../api-urls";
import { useDispatch,useSelector } from "react-redux";
import { fetchCartItems } from "./cartProvider";

const getAuthToken = () => {
  const token = localStorage.getItem("authToken");
  return token ? `Bearer ${token}` : null;
};




export const fetchCoupons = async () => {

  const token = getAuthToken();

  if (!token) {
    console.error("Authentication token missing.");
    return { data: null, error: "Authentication required" };
  }

  try {
    console.log("Fetching coupons data...");
    const response = await axios.get(`${API_ENDPOINTS.coupons}/getAllCoupons`, {
      headers: { Authorization: token },
    });

    console.log("Full API Response:", response);

    if (response.status === 200 && response.data?.coupons) {
      console.log("Extracted Coupons Data:", response.data.coupons);
      return { data: response.data.coupons, error: null };
    } else {
      console.error("Unexpected Response Structure:", response.data);
      return { data: null, error: "Unexpected response format" };
    }
  } catch (error) {
    console.error("Error fetching coupons data:", error.response?.data || error.message);
    return { data: null, error: "Failed to load coupons" };
  }
};

export const fetchRelatedCoupons = async () => {
  const token = getAuthToken();

  if (!token) {
    console.error("Authentication token missing.");
    return { data: null, error: "Authentication required" };
  }

  try {
    console.log("Fetching coupons data...");
    const response = await axios.get(`${API_ENDPOINTS.coupons}`, {
      headers: { Authorization: token },
    });

    console.log("Full API Response:", response.data);

    if (response.status === 200 && response.data?.success) {
      return {
        data: {
          feasibleCoupons: response.data.feasibleCoupons || [],
          nonFeasibleCoupons: response.data.nonFeasibleCoupons || [],
        },
        error: null,
      };
    } else {
      console.error("Unexpected Response Structure:", response.data);
      return { data: null, error: "Unexpected response format" };
    }
  } catch (error) {
    console.error("Error fetching coupons data:", error.response?.data || error.message);
    return { data: null, error: "Failed to load coupons" };
  }
};


export const applyCouponAPI = async (couponCode) => {
  
  const token = getAuthToken();

  if (!token) {
    console.error("Authentication token is missing.");
    return { data: null, error: "Authentication required" };
  }

  try {
    console.log("Applying coupon with code:", couponCode);
    console.log("API Endpoint:", API_ENDPOINTS.coupons); // Debugging log

    const response = await axios.post(
      API_ENDPOINTS.coupons,
      { code: couponCode }, // No user_id
      { headers: { Authorization: token } }
    );

    console.log("Full API Response:", response); // Log full response
    
    // fetchCartItems();
    if (response.status === 200) {
      console.log("Response Data:", response.data); // Log extracted response data

      if (response.data?.success) {
        console.log("Coupon applied successfully! Discount:", response.data.discount);
        return { data: response.data, error: null };
      } else {
        console.error("Coupon application failed:", response.data.message || "Unknown error");
        return { data: null, error: response.data?.message || "Failed to apply coupon" };
      }
    } else {
      console.error("Unexpected response status:", response.status);
      return { data: null, error: "Unexpected response status" };
    }
  } catch (error) {
    console.error("Error applying coupon:", error.response?.data || error.message);
    return { data: null, error: error.response?.data?.message || "Failed to apply coupon" };
  }
};

export const removeCouponAPI = async () => {
  const token = getAuthToken();

  if (!token) {
    console.error("Authentication token is missing.");
    return { data: null, error: "Authentication required" };
  }

  try {
    console.log("Removing applied coupon...");
    console.log("API Endpoint:", `${API_ENDPOINTS.coupons}removeCoupon`); // Debugging log

    const response = await axios.post(`${API_ENDPOINTS.coupons}removeCoupon`,{}, {
      headers: { Authorization: token }, // Fix headers
    });

    console.log("Full API Response:", response); // Log full response

    if (response.status === 200 && response.data?.success) {
      console.log("Coupon removed successfully!");
      return { 
        data: response.data.userCart,  // Return updated cart details
        error: null 
      };
    } else {
      console.error("Failed to remove coupon:", response.data?.message || "Unknown error");
      return { data: null, error: response.data?.message || "Failed to remove coupon" };
    }
  } catch (error) {
    console.error("Error removing coupon:", error.response?.data || error.message);
    return { data: null, error: error.response?.data?.message || "Failed to remove coupon" };
  }
};
